var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","min-height":"1100px"},attrs:{"src":_vm.url,"frameborder":"0"},on:{"load":_vm.handleIframe}})])
}
var staticRenderFns = []

export { render, staticRenderFns }